import { useState } from "react";
import { toast } from "sonner";
import { ArrowRight, MailCheck } from "lucide-react";
import { Reveal } from "@/components/motion-primitives";
import { submitLead, formatApiError } from "@/lib/api";

export default function Newsletter() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await submitLead("newsletter", { email, source: "resource_center" });
      setDone(true);
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="bg-navy text-ivory" data-testid="newsletter-section">
      <div className="noise-overlay mx-auto max-w-[1440px] px-6 py-20 lg:px-10 lg:py-24">
        <div className="grid items-center gap-10 lg:grid-cols-2">
          <Reveal>
            <div>
              <p className="text-[11px] font-semibold uppercase tracking-[0.3em] text-bermuda">The Owner's Letter</p>
              <h2 className="mt-4 font-serif text-3xl sm:text-4xl font-light leading-tight tracking-tight">
                Bermuda rental insight, <span className="italic text-bermuda">worth opening.</span>
              </h2>
              <p className="mt-4 max-w-md text-sm leading-relaxed text-ivory/65">
                Occasional, genuinely useful notes for Bermuda property owners — regulation changes, seasonal
                strategy, pricing movement and lessons from the island's best-run rentals. No noise.
              </p>
            </div>
          </Reveal>
          <Reveal delay={0.15}>
            {done ? (
              <div className="flex items-center gap-4 border border-bermuda/40 bg-white/5 p-6" data-testid="newsletter-success">
                <MailCheck size={22} className="shrink-0 text-bermuda" strokeWidth={1.5} />
                <p className="text-sm leading-relaxed text-ivory/85">
                  You're on the list. The next Owner's Letter will find you — welcome.
                </p>
              </div>
            ) : (
              <form onSubmit={onSubmit} className="flex flex-col gap-3 sm:flex-row" data-testid="newsletter-form">
                <input
                  type="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Your email address"
                  data-testid="newsletter-email-input"
                  className="flex-1 border border-white/20 bg-white/5 px-5 py-4 text-sm text-ivory placeholder:text-ivory/40 outline-none transition-colors focus:border-bermuda"
                />
                <button
                  type="submit"
                  disabled={loading}
                  data-testid="newsletter-subscribe-btn"
                  className="group inline-flex items-center justify-center gap-2.5 bg-bermuda px-7 py-4 text-[11px] font-semibold uppercase tracking-[0.18em] text-navy transition-colors hover:bg-ivory disabled:opacity-60"
                >
                  {loading ? "Subscribing…" : "Subscribe"}
                  {!loading && <ArrowRight size={14} className="transition-transform duration-300 group-hover:translate-x-1" />}
                </button>
              </form>
            )}
          </Reveal>
        </div>
      </div>
    </section>
  );
}
